import { render, staticRenderFns } from "./FValidatorDetail.vue?vue&type=template&id=20a1fc1f&"
import script from "./FValidatorDetail.vue?vue&type=script&lang=js&"
export * from "./FValidatorDetail.vue?vue&type=script&lang=js&"
import style0 from "./FValidatorDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports